/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const REJECTION_REASONS = [
  'inappropriate',
  'misdetected',
  'explicit',
  'unwanted',
  'quality',
  'timing',
  'other',
] as const;

export const rejectionReasonSchema = z.enum(REJECTION_REASONS);

export type ITriageRejectionReason = z.infer<typeof rejectionReasonSchema>;

export const REJECTION_REASON_LABELS: Record<ITriageRejectionReason, string> = {
  inappropriate: 'Inappropriate',
  misdetected: 'Misdetected',
  explicit: 'Explicit',
  unwanted: 'Unwanted',
  quality: 'Bad Quality',
  timing: 'Bad Timing',
  other: 'Other',
};
